import { getUserData } from 'app/store/actions/user/user.actions';
import axios from 'axios';

export const GET_TEAM_PROJECTS = '[CONTACTS APP] GET TEAM PROJECTS';
export const GET_TEAM_USERS = '[CONTACTS APP] GET TEAM USERS';
export const MEMBER_SEARCH_TEXT = '[CONTACTS APP] MEMBER SEARCH TEXT';
export const OPEN_NEW_CONTACT_DIALOG = '[CONTACTS APP] OPEN NEW CONTACT DIALOG';
export const CLOSE_NEW_CONTACT_DIALOG = '[CONTACTS APP] CLOSE NEW CONTACT DIALOG';
export const OPEN_EDIT_CONTACT_DIALOG = '[CONTACTS APP] OPEN EDIT CONTACT DIALOG';
export const CLOSE_EDIT_CONTACT_DIALOG = '[CONTACTS APP] CLOSE EDIT CONTACT DIALOG';
export const ADD_CONTACT = '[CONTACTS APP] ADD CONTACT';
export const UPDATE_CONTACT = '[CONTACTS APP] UPDATE CONTACT';
export const REMOVE_CONTACT = '[CONTACTS APP] REMOVE CONTACT';
export const REMOVE_CONTACTS = '[CONTACTS APP] REMOVE CONTACTS';
export const TOGGLE_STARRED_CONTACT = '[CONTACTS APP] TOGGLE STARRED CONTACT';
export const TOGGLE_STARRED_CONTACTS = '[CONTACTS APP] TOGGLE STARRED CONTACTS';
export const SET_CONTACTS_STARRED = '[CONTACTS APP] SET CONTACTS STARRED ';
export const SWITCH_HEADER = '[CONTACTS APP] SWITCH HEADER';
export const TEAM_NAME = '[CONTACTS APP] TEAM NAME';
export const HANDLE_PROJECTS = '[CONTACTS APP] HANDLING PROJECTS LIST';
export const HANDLE_USERS_DETAILS = '[CONTACTS APP] HANDLING USERS DETAILS';
export const MAPPING_SEARCH_PROJECTS = '[CONTACTS APP] MAPPING SEARCH PROJECTS';
export const MAPPING_SEARCH_TEAMS = '[CONTACTS APP] MAPPING SEARCH TEAMS';
export const SET_FILTER_CHECKBOX = '[CONTACTS APP] FILTER CHECKBOX';
export const HANDLING_FILTERED_DATA = '[CONTACTS APP] HANDLING FILTERED DATA';


export function getTeamProjects(routeParams) {
	// const request = axios.get('/api/contacts-app/contacts', {
	// 	params: routeParams
	// });
	let data = [
		{no: '1', team: 'Team Management A', projects:'Tokyo Project 001, Tokyo Project Site Construction, Tokyo Project 002, Tohoku Site Project 003, Hokkaido Site Project 001, Tokyo Project 006, Tokyo Project Site Construction, Tokyo Project 008, Tohoku Site Project 013, Hokkaido Site Project 011', groupProject: 'Tokyo Arquitecture (07), Tokyo Civil (17), Nagoya Arquitecture (04),  Nagoya Civil (04)', totalMembers:'20' , email: 'samurai.adhzm@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Head Admin', name: 'Sbrubleee',  totalProject: '40', status: 'Active'},
		{no: '2', team: 'Team Management B', projects:'Tokyo Project 001, Tohoku Site Project 003, Hokkaido Site Project 001', groupProject: 'Tokyo Civil (17), Tokyo Arquitecture (02)', totalMembers:'10' , email: 'hasegawa.takahiro@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Site Office', memberType: 'Branch Admin', name: 'Hasegawa Takahiro', totalProject: '24', status: 'Active'},
		{no: '3', team: 'Team Management C', projects:'Tokyo Project 001', groupProject: 'Touhoku Arquitecture (20), Touhoku Civil (04)', totalMembers:'12' , email: 'upen@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Site Office', memberType: 'Site Admin', name: 'upen-adhzm', totalProject: '40', status: 'Inactive'},
		{no: '4', team: 'Team Management D', projects:'Tokyo Project 003, Tokyo Project Site Construction, Tokyo Project 012,Tokyo Project 010, Tokyo Project Site Construction, Tokyo Project 022, Tokyo Project 008, Tokyo Project Site Construction, Tokyo Project 062',groupProject: 'Touhoku Civil (05), Touhoku Arquitecture (03), Touhoku Civil (33)', totalMembers:'20' , email: 'test_julien@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Branch Office', memberType: 'Site Admin', name: 'julien', totalProject: '53', status: 'Inactive'},
		{no: '5', team: 'Team Management E', projects:'Tokyo Project Site Construction, Tokyo Project 002, Tohoku Site Project 003, Hokkaido Site Project 001', groupProject: 'Osaka Arquitecture (30), Osaka Civil (09), Touhoku Civil (04), Nagoya Arquitecture (22)', totalMembers:'25', email: 'uttam_jv@ad-hzm.co.jp', groupType: 'Other', affiliation: 'Branch Office', memberType: 'Site Admin', name: 'Uttam_JV', totalProject: '52', status: 'Active'},
		{no: '6', team: 'Team Management F', projects:'Tohoku Site Project 003, Hokkaido Site Project 001', groupProject: 'Osaka Civil (10), Osaka Arquitecture (20), Tokyo Civil (04)', totalMembers:'05', email: 'ashutosh.utokyo@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'User', name: 'Ashutosh', totalProject: '17', status: 'Active'},
		{no: '7', team: 'Team Management G', projects:'Tokyo Project 002, Tohoku Site Project 003, Hokkaido Site Project 001', groupProject: 'Okinawa Arquitecture (18)', totalMembers:'12', email: 'test-user-001@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Admin', totalProject: '10', status: 'Active'},
		{no: '8', team: 'Team Management H', projects:'Hokkaido Site Project 001', groupProject: 'Okinawa Civil (08)', totalMembers:'07', email: 'ah_team@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'test-AH-0', totalProject: '33', status: 'Deleted'},
		{no: '9', team: 'Team Management I', projects:'Tohoku Site Project 003, Hokkaido Site Project 001', groupProject: 'Hokaido Arquitecture (22)', totalMembers:'30',email: 'fake4@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'fake fourth', totalProject: '27', status: 'Deleted'},
		{no: '10', team: 'Team Management J', projects:'Tokyo Project 001, Tokyo Project 002, Tohoku Site Project 003', groupProject: 'Hokaido Civil (11)', totalMembers:'34', email: 'test1@gmail.com', groupType: 'Other', affiliation: 'Head Office', memberType: 'Site Admin', name: 'test', totalProject: '11', status: 'Active'},
		{no: '11', team: 'Team Management K', projects:'Tohoku Site Project 003, Hokkaido Site Project 001', groupProject: 'Hokaido Arquitecture (20), Osaka Arquitecture (30), Osaka Civil (09), Touhoku Civil (04), Nagoya Arquitecture (22)', totalMembers:'19', email: 'upsys921@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'upendtu up', totalProject: '10', status: 'Active'},
		{no: '12', team: 'Team Management L', projects:'Tokyo Project 002, Tohoku Site Project 003, Hokkaido Site Project 001', groupProject: 'Hokkaido Civil (10)', totalMembers:'22', email: 'fake3@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'fake third1', totalProject: '13', status: 'Active'},
		{no: '13', team: 'Team Management M', projects:'Tokyo Project Site Construction, Hokkaido Site Project 001', groupProject: 'Hokkaido Arquitecture (11), Tokyo Arquitecture (07), Tokyo Civil (17), Nagoya Arquitecture (04)', totalMembers:'16', email: 'sugiyama.ritsu@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Ritsu Sugiyama', totalProject: '30', status: 'Active'},
		/*{no: '14', email: 'juliens@gmail.com', groupType: 'JV staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'JULIEN LAGLASSE', totalProject: '7', status: 'Deleted'},
		{no: '15', email: 'julienlaglasse+3@gmail.com', groupType: 'JV staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'JULIEN LAGLASSE', totalProject: '7', status: 'Active'},
		{no: '16', email: 'chayut.dev01@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Ton test', totalProject: '1', status: 'Active'},
		{no: '17', email: 'julienlstark+6@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'JULIEN LAGLASSE', totalProject: '7', status: 'Active'},
		{no: '18', email: 'julieanlstark@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'LAGLASSE Juliena', totalProject: '7', status: 'Active'},
		{no: '19', email: 'juliessnlstark@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'JULIENss', totalProject: '7', status: 'Active'},
		{no: '20', email: 'newNaeme@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'newName', totalProject: '7', status: 'Active'},
		{no: '21', email: 'julienlaglasse@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Julien1', totalProject: '7', status: 'Active'},
		{no: '22', email: 'julienfflstark@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'LfffAGLASSE Julien', totalProject: '7', status: 'Active'},
		{no: '23', email: 'julienlfdsstark@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'LAGLASSE Julienfds', totalProject: '7', status: 'Active'},
		{no: '24', email: 'testUser@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'testUser', totalProject: '2', status: 'Active'},
		{no: '25', email: 'julienlstark+9@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'JULIEN LAGLASSE', totalProject: '7', status: 'Active'},
		{no: '26', email: 'test-user-002@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'test user 002', totalProject: '7', status: 'Active'},
		{no: '27', email: 'uttamdwivedi04@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Uttam G', totalProject: '3', status: 'Active'},
		{no: '28', email: 'fake2@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'fake second', totalProject: '7', status: 'Active'},
		{no: '29', email: 'koderboxx@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'koderboxx', totalProject: '1', status: 'Active'},
		{no: '30', email: 'adhzm.samurai@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'ADHZM SAMURAI', totalProject: '3', status: 'Active'},
		{no: '31', email: 'upsys92@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'upendra-99', totalProject: '5', status: 'Active'},
		{no: '32', email: 'nickkami@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Nick Kamimura', totalProject: '1', status: 'Active'},
		{no: '33', email: 'morosawa.masanori@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Morosawa Masanori', totalProject: '1', status: 'Active'},
		{no: '34', email: 'julienlaglasse+2@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'JULIEN LAGLASSE', totalProject: '7', status: 'Active'},
		{no: '35', email: 'test_ash@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Ash', totalProject: '1', status: 'Active'},
		{no: '36', email: 'yoshida.nao@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Yoshida Nao', totalProject: '1', status: 'Active'},
		{no: '37', email: 'scai.adhzm@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'scai adhzm', totalProject: '7', status: 'Active'},
		{no: '38', email: 'fakemail@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'fake email', totalProject: '7', status: 'Active'},
		{no: '39', email: 'error_test@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'error test', totalProject: '1', status: 'Active'},
		{no: '40', email: 'testfake@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'testfake', totalProject: '7', status: 'Active'},
		{no: '41', email: 'uttamdwivedi.utokyo@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'UTM-U', totalProject: '1', status: 'Active'},
		{no: '42', email: 'test-user-001@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'test-user-001', totalProject: '2', status: 'Active'},
		{no: '43', email: 'clue@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Clue', totalProject: '7', status: 'Active'},
		{no: '44', email: 'flynn@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Flynn', totalProject: '1', status: 'Active'},
		{no: '45', email: 'clue1@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Clue2', totalProject: '2', status: 'Active'},*/
	];
	return {
		type: GET_TEAM_PROJECTS,
		payload: data,
	};
}

export function getTeamUsers(routeParams) {
	let data = [
		{no: '1', email: 'samurai.adhzm@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Head Admin', name: 'Admin Work',  totalProject: '7', status: 'Active'},
		{no: '2', email: 'hasegawa.takahiro@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Site Office', memberType: 'Branch Admin', name: 'Hasegawa Takahiro', totalProject: '4', status: 'Active'},
		{no: '3', email: 'upen@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Site Office', memberType: 'Site Admin', name: 'upen-adhzm', totalProject: '2', status: 'Active'},
		{no: '4', email: 'test_julien@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Branch Office', memberType: 'Site Admin', name: 'julien', totalProject: '3', status: 'Active'},
		{no: '5', email: 'uttam_jv@ad-hzm.co.jp', groupType: 'Other', affiliation: 'Branch Office', memberType: 'Site Admin', name: 'Uttam_JV', totalProject: '1', status: 'Active'},
		{no: '6', email: 'ashutosh.utokyo@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'User', name: 'Ashutosh', totalProject: '7', status: 'Active'},
		{no: '7', email: 'test-user-001@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Admin', totalProject: '7', status: 'Active'},
		{no: '8', email: 'ah_team@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'test-AH-0', totalProject: '3', status: 'Active'},
		{no: '9', email: 'fake4@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'fake fourth', totalProject: '7', status: 'Active'},
		{no: '10', email: 'test1@gmail.com', groupType: 'Other', affiliation: 'Head Office', memberType: 'Site Admin', name: 'test', totalProject: '7', status: 'Active'},
		{no: '11', email: 'upsys921@gmail.com', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'upendtu up', totalProject: '2', status: 'Active'},
		{no: '12', email: 'fake3@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'fake third1', totalProject: '3', status: 'Active'},
		{no: '13', email: 'sugiyama.ritsu@ad-hzm.co.jp', groupType: 'Main office staff', affiliation: 'Head Office', memberType: 'Site Admin', name: 'Ritsu Sugiyama', totalProject: '3', status: 'Active'},
	];
	return {
		type: GET_TEAM_USERS,
		payload: data,
	};
}

export function handlingFilteredData(data){
	return{
		type: HANDLING_FILTERED_DATA,
		payload: data
	}
}

export function searchFilterCheckbox(data) {
	return {
		type: SET_FILTER_CHECKBOX,
		payload: data
	};
}

export function handleUsersDetails(data){
	return{
		type: HANDLE_USERS_DETAILS,
		payload: data
	}
}

export function searchTeams(event) {
	return {
		type: MAPPING_SEARCH_TEAMS,
		payload: event.target.value
	};
}

export function searchProjects(event) {
	return {
		type: MAPPING_SEARCH_PROJECTS,
		payload: event.target.value
	};
}

export function teamName(data) {
	//console.log("teamName actions",data.teamName)
	return {
		type: TEAM_NAME,
		team: data.teamName,
	};
}

export function handleProjects(data){
	return{
		type: HANDLE_PROJECTS,
		payload: data
	}
}

export function switchHeader(data) {
	//console.log("switchHeader actions",data.switchHeader)
	return {
		type: SWITCH_HEADER,
		header: data.switchHeader,
	};
}

export function searchMember(event) {
	return {
		type: MEMBER_SEARCH_TEXT,
		searchMember: event.target.value
	};
}

export function openNewContactDialog() {
	return {
		type: OPEN_NEW_CONTACT_DIALOG
	};
}

export function closeNewContactDialog() {
	return {
		type: CLOSE_NEW_CONTACT_DIALOG
	};
}

export function openEditContactDialog(data) {
	return {
		type: OPEN_EDIT_CONTACT_DIALOG,
		data
	};
}

export function closeEditContactDialog() {
	return {
		type: CLOSE_EDIT_CONTACT_DIALOG
	};
}

export function addContact(newContact) {
	return (dispatch, getState) => {
		const { routeParams } = getState().addmemberUsersApp.contacts;

		const request = axios.post('/api/contacts-app/add-contact', {
			newContact
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: ADD_CONTACT
				})
			]).then(() => dispatch(getTeamProjects(routeParams)))
		);
	};
}

export function updateContact(contact) {
	return (dispatch, getState) => {
		const { routeParams } = getState().addmemberUsersApp.contacts;

		const request = axios.post('/api/contacts-app/update-contact', {
			contact
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: UPDATE_CONTACT
				})
			]).then(() => dispatch(getTeamProjects(routeParams)))
		);
	};
}

export function removeContact(contactId) {
	return (dispatch, getState) => {
		const { routeParams } = getState().addmemberUsersApp.contacts;

		const request = axios.post('/api/contacts-app/remove-contact', {
			contactId
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: REMOVE_CONTACT
				})
			]).then(() => dispatch(getTeamProjects(routeParams)))
		);
	};
}

export function removeContacts(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().addmemberUsersApp.contacts;

		const request = axios.post('/api/contacts-app/remove-contacts', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: REMOVE_CONTACTS
				})
			]).then(() => dispatch(getTeamProjects(routeParams)))
		);
	};
}

export function toggleStarredContact(contactId) {
	return (dispatch, getState) => {
		const { routeParams } = getState().addmemberUsersApp.contacts;

		const request = axios.post('/api/contacts-app/toggle-starred-contact', {
			contactId
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: TOGGLE_STARRED_CONTACT
				}),
				dispatch(getUserData())
			]).then(() => dispatch(getTeamProjects(routeParams)))
		);
	};
}

export function toggleStarredContacts(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().addmemberUsersApp.contacts;

		const request = axios.post('/api/contacts-app/toggle-starred-contacts', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: TOGGLE_STARRED_CONTACTS
				}),
				dispatch(getUserData())
			]).then(() => dispatch(getTeamProjects(routeParams)))
		);
	};
}

export function setContactsStarred(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().addmemberUsersApp.contacts;

		const request = axios.post('/api/contacts-app/set-contacts-starred', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: SET_CONTACTS_STARRED
				}),
				dispatch(getUserData())
			]).then(() => dispatch(getTeamProjects(routeParams)))
		);
	};
}

export function setContactsUnstarred(contactIds) {
	return (dispatch, getState) => {
		const { routeParams } = getState().addmemberUsersApp.contacts;

		const request = axios.post('/api/contacts-app/set-contacts-unstarred', {
			contactIds
		});

		return request.then(response =>
			Promise.all([
				dispatch({
					type: SET_CONTACTS_STARRED
				}),
				dispatch(getUserData())
			]).then(() => dispatch(getTeamProjects(routeParams)))
		);
	};
}
